/*
 * Update-product.ts
 * Description: Includes the declaration
 * of the function for updating a product
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing an interface
import {Product} from '@/ts/products/validate-product';

/**
 * Updating a product
 *
 * @return {Object} Promise - an updated product
 * @param {String} slug - id of a restaurant
 * @param {Number} productId - id of a category
 * @param {Product} data - product data
 */
export function updateProduct(data: Product, slug: string, productId: number) {
    const jwt = localStorage.getItem('jwt');
    if (data.description === null) { data.description = ''; }
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/products/' + productId,
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch((error) => {
            reject(error);
        });
    });
}
